/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useEffect, useState } from "react";
import FontFa from "../../../../components/fontFa/fontFa";
import { documentStatus } from "../../../../constants/statusConstants";
import { getTitleForDocument } from "../../util";
import React from "react";
import { Button } from "devextreme-react/button";
import { InputCheckbox } from "../../../../components/input/checkbox";
import DropDownButton from "devextreme-react/drop-down-button";
import { getDDMMYYYFormat, getDiffDay } from "../../../../helper/dateTimeHelper";
import { useSelector } from "../../../../store/store";
import { Badge } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useDocumentTags } from "../../../setting/document/document-tags/hooks/useDocumentTags";
import moment from "moment";
import { DateFormat } from "../../../../constants";
import { useDocumentOrder } from "../../hooks/use-document-order";

const today = new Date();

export const DocumentDataGridItem = (props: any) => {
  const {
    document,
    statusView,
    isShowAction,
    isShowCheckColumn,
    goToDetail,
    goToPermission,
    goToDetailProcess,
    // goToTeams,
    deleteConfirmDialog,
    openDocumentUrl,
    onSelectedDocument,
    searchInputValue,
    listId,
    filterExpired,
    currentEmail,
    getDocumentLinkExpired,
  } = props;

  const [documentTitle, setDocumentTitle] = useState<any>();
  const [contextActions, setContextActions] = useState<any[]>([]);
  const buttonDropDownOptions = { width: 180 };
  const [expiredDate, setExpiredDate] = useState(null as any);
  const userAdmin = useSelector((state) => state.userAdmin);
  const [className, setClassName] = useState<string>("");
  const history = useHistory();
  const { getTagLabel } = useDocumentTags();

  const { selectedId, changeSelectedId, onPressEnterInput, OrderInput } = useDocumentOrder();

  const isDocumentSelected = selectedId === document.id;

  const getIcon = () => {
    switch (document.type) {
      case "doc":
      case "docx":
        return <FontFa name="faFileWord" size="lg" color={"#0F4C81"} />;
      case "pptx":
      case "ppt":
        return <FontFa name="faFilePowerpoint" size="lg" color={"#D04423"} />;
      case "xlsx":
        return <FontFa name="faFileExcel" size="lg" color={"#1d6f42"} />;
      case "pdf":
        return <FontFa name="faFilePdf" size="lg" color={"#B0171F"} />;
      default:
        return <FontFa name="faFileCode" size="lg" />;
    }
  };

  const isExpired = () => {
    if (!document) return false;
    if (statusView === documentStatus.publish.value && filterExpired && filterExpired !== "false") return true;
    if (!document.expiredDate) return false;
    return document?.docStatusValue === "publish" && moment(document?.expiredDate).isSameOrBefore(moment());
  };

  const processContextActions = useCallback(() => {
    const actions: any = [];

    //actions.push({ id: 1, name: 'Xem nội dung tài liệu', icon: 'textdocument', action: openDocumentUrl });

    if (statusView !== documentStatus.publish.value) {
      // actions.push({ id: 2, name: 'Chỉnh sửa thông tin', icon: 'edit', action: goToDetailEdit });
      //actions.push({ id: 3, name: 'Phân quyền', icon: 'lock', action: goToPermission });
      actions.push({ id: 4, name: "Xử lý quy trình", icon: "preferences", action: goToDetailProcess });
    }

    // actions.push({ id: 5, name: "Thảo luận", icon: "comment", action: goToTeams });

    if (
      statusView !== documentStatus.publish.value &&
      currentEmail?.toLowerCase() === document?.createdUser?.email &&
      document.docStatusValue !== "interimpublish" &&
      document.docStatusValue !== "publish"
    ) {
      actions.push({ id: 6, name: "Xóa tài liệu", icon: "trash", action: deleteConfirmDialog });
    }

    setContextActions(actions);
  }, [
    currentEmail,
    deleteConfirmDialog,
    document?.createdUser?.email,
    document.docStatusValue,
    goToDetailProcess,
    statusView,
  ]);

  const contextActionItemClick = (e: any) => {
    if (e.itemData.action) {
      e.itemData.action(document);
    }
  };

  const isExpiredInWeek = () => {
    return expiredDate < 7 && expiredDate >= 0;
  };

  const isAdmin = () => {
    if (userAdmin && userAdmin.id) return true;
    else if (expiredDate > 0) return true;
    else return false;
  };

  const handleTitleClick = () => {
    goToDetail(document, "info");
  };

  const getFolderName = (url: string) => {
    if (!url) return;
    if (url) {
      const path = new URL(url).pathname;
      const folders = path.split("/");

      // "SecondFolder" will be at index 4 in the folders array
      const secondFolder = folders.slice(-1);
      let startIndex = url.indexOf("vnWorkingDocs/") + "vnWorkingDocs/".length;
      if (listId) {
        startIndex = url.indexOf("vnPublishDocs/") + "vnPublishDocs/".length;
      }
      const lastIndex = url.indexOf("/" + secondFolder[0]);
      const subString = url.substring(startIndex, lastIndex);

      if (!subString.startsWith("T%C3%80I%20LI%E1%BB%86U")) return "";

      return (
        <p className="py-2">
          <FontFa name="faFolder" color="orange" /> {decodeURIComponent(subString).replaceAll("/", " ⏵ ")}
        </p>
      );
    }
  };

  const getClassName = useCallback(async () => {
    if (statusView === "publish" && userAdmin && userAdmin.id && expiredDate <= 0) return "text-danger main-row";
    if (statusView === "publish" && document.docStatusValue === "interimpublish" && userAdmin && userAdmin.id)
      return "text-warning main-row";
    if (!statusView) {
      if (!getDocumentLinkExpired) return "main-row";
      const isExpired = await getDocumentLinkExpired(document.listItemId);
      if (isExpired) return "main-row blink-expired";
    }
    return "main-row";
  }, [document.docStatusValue, document.listItemId, expiredDate, getDocumentLinkExpired, statusView, userAdmin]);

  const fetchClassName = useCallback(async () => {
    const className = await getClassName();
    setClassName(className);
  }, [getClassName]);

  useEffect(() => {
    if (document) {
      setDocumentTitle(getTitleForDocument(document));

      setExpiredDate(
        document?.expiredDate
          ? getDiffDay(today.toDateString(), document?.expiredDate)
          : getDiffDay(today.toDateString(), document?.effectiveTo),
      );

      if (isShowAction) {
        processContextActions();
      }

      fetchClassName();
    }
  }, [document, fetchClassName, isShowAction, processContextActions, searchInputValue]);

  return (
    document &&
    isAdmin() && (
      <React.Fragment>
        <tr className={className}>
          {isShowCheckColumn && (
            <td>
              <InputCheckbox
                name="checkbox"
                label=""
                onTouched={() => false}
                onChange={(e) => onSelectedDocument(document, e)}
                value={undefined}
              />
            </td>
          )}
          {isShowAction && (
            <td>
              <Button
                onClick={() => openDocumentUrl(document)}
                hint="Xem nội dung tài liệu"
                icon="textdocument"
                className="icon-document"
              />
              <Button
                onClick={() => goToPermission(document)}
                hint={
                  statusView !== documentStatus.publish.value ? "Phân quyền kiểm soát tài liệu" : "Phân phối tài liệu"
                }
                icon={statusView !== documentStatus.publish.value ? "share" : "lock"}
                className="icon-document"
              />
              {contextActions?.length > 0 && (
                <DropDownButton
                  icon="more"
                  items={contextActions}
                  displayExpr="name"
                  keyExpr="id"
                  splitButton={false}
                  onItemClick={contextActionItemClick}
                  className="icon-document-dropdown"
                  dropDownOptions={buttonDropDownOptions}
                />
              )}
            </td>
          )}
          <td>
            <a
              title={documentTitle}
              className={
                isExpiredInWeek() && statusView === "publish"
                  ? "text__title-container expired"
                  : statusView === "publish" && userAdmin && userAdmin.id && expiredDate <= 0
                  ? "text-danger text__title-container"
                  : "text__title-container"
              }
              onClick={(e: any) => {
                e.stopPropagation();
                handleTitleClick();
              }}
            >
              {getIcon()} <span className="px-1">{documentTitle}</span>
            </a>
            {getFolderName(document.docUrl ?? document.url)}
          </td>
          <td title={document.docCode}>{document.docCode}</td>
          <td title={document.docType}>{document.docType}</td>
          <td title={!isExpired() ? document.docStatus : "Tài liệu lỗi thời"}>
            {!isExpired() ? document.docStatus : "Tài liệu lỗi thời"}
          </td>
          {/* new */}

          <td title={document.effectiveFrom ?? document.effectiveDate ?? document.lastModifiedDateTime}>
            {getDDMMYYYFormat(document.effectiveFrom ?? document.effectiveDate ?? document.lastModifiedDateTime)}
          </td>
          <td title={document.docPublishViewVersion}>{document.docPublishViewVersion}</td>
          <td title={document.docEditionVersion}>{document.docEditionVersion}</td>
          {/* end new */}
          <td title={document.createdDateTime}>
            {moment(document.createdDateTime).format(DateFormat.DD_MM_YYYY_HH_MM)}
          </td>
          <td style={{ whiteSpace: "nowrap" }} title={document.createdUser?.displayName}>
            {document.createdUser?.displayName}
          </td>
          <td title={document.lastModifiedDateTime}>
            {moment(document.lastModifiedDateTime).format(DateFormat.DD_MM_YYYY_HH_MM)}
          </td>
          <td style={{ whiteSpace: "nowrap" }} title={document.modifiedUser?.displayName}>
            {document.modifiedUser?.displayName}
          </td>
          <td>
            {document.Tags?.map((tags: any, index: number) => (
              <Badge
                variant="secondary"
                className="mx-1 "
                key={index}
                onClick={() => history.push(`/document?status=tags&tags=${tags?.label || tags.toString()}`)}
              >
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "50px",
                    wordWrap: "break-word",
                  }}
                >
                  {getTagLabel(tags)}
                </span>
              </Badge>
            ))}
          </td>
          {statusView === documentStatus.publish.value && !filterExpired && (
            <td title={document.id} onClick={() => changeSelectedId(document.id)}>
              {!isDocumentSelected && (
                <span style={{ display: "inline-flex", height: "29px", alignItems: "center" }}>
                  {document?.docOrder}
                </span>
              )}
              {isDocumentSelected && (
                <OrderInput
                  defaultValue={document?.docOrder}
                  onEnter={(info) => onPressEnterInput({ ...info, data: document })}
                />
              )}
            </td>
          )}
        </tr>
      </React.Fragment>
    )
  );
};
